import './App.css';

import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import AuthService from './services/AuthService';
import { BlogPage } from './components/Blog/BlogPage.jsx';
import { BlogsPage } from './components/Blog/BlogsPage.jsx';
import DigitalSAT from './features/DigitalSAT.jsx';
import ExamInterface from './components/pages/ExamInterface.jsx';
import ExamScore from './features/ExamScore.jsx';
import FAQ from '../src/features/FAQ.jsx';
import FlashcardItem from './components/templates/flashcards/FlashcardItem.jsx';
import FlashcardsPage from './components/templates/flashcards/FlashcardsPage.jsx';
import GlobalModals from './components/GlobalModals.jsx';
import HomePage from './components/templates/HomePage.jsx';
import KnowledgeConceptPage from './components/templates/knowledge-concept/KnowledgeConceptPage.jsx';
import LoadingTest from './components/LoadingTest.jsx';
import { ModalProvider } from './context.js/ModalContext.js';
import Navbar from './components/templates/NavBar.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import SFTDashboard from './components/SFT/SFTDashboard.jsx';
import TestInstructions from './components/TestInstructions.jsx';
import TopicSelection from './components/templates/knowledge-concept/quiz/TopicSelection.jsx';
import UserDetail from './features/UserDetail.jsx';
import { useState } from 'react';
import PaymentPage from './features/PaymentPage.jsx';
import PlansAndPricing from './features/PlanAndPricing.jsx';
import PaymentSuccessPage from './features/PaymentSuccessPage.jsx';
import PaymentFailurePage from './features/PaymentFailurePage.jsx';
import PerformaceAnalytics from './features/performance-analytics/PerformanceAnalytics.jsx';
import AchievementsDashboard from './features/achievements/AchievementsDashboard.jsx';

function AppContent() {
	const location = useLocation();

	const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
	const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);

	const openLoginModal = () => {
		setIsSignUpModalOpen(false);
		setIsLoginModalOpen(true);
	};
	const closeLoginModal = () => setIsLoginModalOpen(false);
	const openSignUpModal = () => {
		setIsLoginModalOpen(false);
		setIsSignUpModalOpen(true);
	};
	const closeSignUpModal = () => {
		//  const confirmation = window.confirm(
		// 	"Your registration isn’t complete yet. If you leave now, any progress you’ve made will be lost. Are you sure you want to leave?"
		// );
		// if (confirmation) {
		setIsSignUpModalOpen(false);
		//}
	};

	const handleOverlayClick = (e, closeModal) => {
		if (e.target.className === 'modal-overlay' || e.target.className === 'plan-button') {
			closeModal();
		}
	};

	return (
		<div className="App">
			{location.pathname !== '/exam-interface' && (
				// <div>
				<Navbar
				// openLoginModal={openLoginModal}
				// openSignUpModal={openSignUpModal}
				// handleOverlayClick={handleOverlayClick}
				/>
				//</div>
			)}
			<GlobalModals />
			<div>
				<Routes>
					<Route
						path="/"
						element={
							<HomePage
								isLoginModalOpen={isLoginModalOpen}
								isSignUpModalOpen={isSignUpModalOpen}
								handleOverlayClick={handleOverlayClick}
								closeLoginModal={closeLoginModal}
								closeSignUpModal={closeSignUpModal}
								openLoginModal={openLoginModal}
								openSignUpModal={openSignUpModal}
							/>
						}
					/>
					<Route path="/blog" element={<BlogsPage />} />
					<Route path="/blogs/:id" element={<BlogPage />} />
					<Route path="/faq" element={<FAQ />} />
					<Route element={<ProtectedRoute />}>
						<Route path="/knowledge_concept" element={<KnowledgeConceptPage />} />
						<Route path="/blog" />
						<Route path="/faq" element={<FAQ />} />
						<Route path="/blog" element={<DigitalSAT />} />
					</Route>

					<Route path="/exam-score" element={<ExamScore />} />
					<Route path="/exam-interface" element={<ExamInterface />} />

					<Route path="/user-detail" element={<UserDetail />} />

					<Route path="/performance-analytics" element={<PerformaceAnalytics />} />

					<Route path="/achievements" element={<AchievementsDashboard />} />

					<Route path="/plans-and-pricing" element={<PlansAndPricing />} />

					<Route path="/payment" element={<PaymentPage />} />
					<Route path="/payment-success" element={<PaymentSuccessPage />} />
					<Route path="/payment-failure" element={<PaymentFailurePage />} />

					<Route path="/test/loading/:testId" element={<LoadingTest />} />
					<Route path="/test-instructions" element={<TestInstructions />} />
					<Route path="/flashcardlist/" element={<FlashcardsPage />} />
					<Route
						path="/flashcard/:topicId/:subtopicId/:subject/:userId/:flashcardId"
						element={<FlashcardItem />}
					/>
					<Route path="/SFT" element={<SFTDashboard />} />
					<Route path="exam" element={<DigitalSAT />} />
					<Route path="/SFT/create" element={<TopicSelection />} />
				</Routes>
			</div>
		</div>
	);
}

function App() {
	return (
		<Router>
			<ModalProvider>
				<AppContent />
			</ModalProvider>
		</Router>
	);
}

export default App;
